module.exports = __webpack_public_path__ + "static/media/filter.ae25f830.svg";